module.exports = __webpack_public_path__ + "img/Cartoon-Book-Club-Drawing-Pixy.b1a201ec.jpg";